<template>
  <PrePeersLegalDocument
    :title="t('legalPages.legalNotice.pageTitle')"
    :highlighted-title-part="t('legalPages.legalNotice.highlightedTitlePart')"
    :html="legalNoticeHtml"
    :has-summary="false">
    <template #footer>
      <PrePeersButton
        variant="primary"
        size="lg"
        :to="localePath('/conditions-generales-utilisation')">
        {{ t('legalPages.legalNotice.termsOfUseButtonLabel') }}
      </PrePeersButton>
    </template>
  </PrePeersLegalDocument>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import legalNoticeHtml from '~/assets/legal/mentions-legales.html?raw'
import PrePeersButton from '~/components/core/PrePeersButton.vue'
import PrePeersLegalDocument from '~/components/sections/PrePeersLegalDocument.vue'

const { t } = useI18n()
const localePath: ReturnType<typeof useLocalePath> = useLocalePath()

definePageMeta({
  layout: 'default',
})

useSeoMeta({
  title: computed(() => t('legalPages.legalNotice.metaTitle')),
  description: computed(() => t('legalPages.legalNotice.metaDescription')),
  ogTitle: computed(() => t('legalPages.legalNotice.metaTitle')),
  ogDescription: computed(() => t('legalPages.legalNotice.metaDescription')),
})
</script>
